import React from 'react'
import { RevenueHeatmapChart } from './RevenueHeatmap'
import { resolveClientSegmentSubtitleLabel } from './NetFlowsHeatmapShared'

const RevenueAssetClassAndGeographyHeatmap = (props) => (
  <RevenueHeatmapChart
    {...props}
    rowAxisLabel="Geography"
    resolveFilterSubtitleLabel={resolveClientSegmentSubtitleLabel}
    accessibilityPointDescription="{series.xAxis.categories.(x)} asset class net revenues {series.yAxis.categories.(y)} geography, {value}."
  />
)

export default RevenueAssetClassAndGeographyHeatmap
